import { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchEmployeeTypes } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const EmployeeTypeDropdown = ({
  errors,
  control,
  setValue,
  rowData,
  required,
  defaultValue,
}) => {
  const {
    data: empTypes,
    isLoading,
    isError,
  } = useQuery(["employeeTypes"], fetchEmployeeTypes, {
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(() => {
    return (
      empTypes?.data?.data?.map((item) => ({
        value: item.id,
        label: item.employee_type,
      })) || []
    );
  }, [empTypes]);

  useEffect(() => {
    const value = rowData?.employee_type_id || defaultValue;

    if (options.length > 0 && value && setValue) {
      const selectedOption = options.find((opt) => opt.value === value);

      if (selectedOption) {
        setValue("employee_type_id", selectedOption.value);
      }
    }
  }, [options, rowData, defaultValue, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading Employee Types</div>;

  return (
    <Controller
      name="employee_type_id"
      control={control}
      defaultValue={defaultValue || ""}
      rules={{
        required: required ? "Employee Type is required" : false,
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Employee Type"
          value={options.find((option) => option.value === field.value) || null}
          onChange={(selectedOption) => {
            const value = selectedOption?.value || "";
            field.onChange(value);
            setValue("employee_type_id", value);
          }}
          className={`react-select-container ${
            errors?.employee_type_id ? "is-invalid" : ""
          }`}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      )}
    />
  );
};

export default EmployeeTypeDropdown;
